import { render } from "./WebUsers.vue?vue&type=template&id=7efa3162"
import script from "./WebUsers.vue?vue&type=script&lang=js"
export * from "./WebUsers.vue?vue&type=script&lang=js"

import exportComponent from "/media/alvian/New Volume14/project/vue js/sfa-nepal-web-report/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__